/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppTemplateArchivePathParams,
	WhatsAppTemplateArchiveResponse,
} from '../types/WhatsAppTemplateArchive'

/**
 * POST /organisations/:organisationId/whatsapp-templates/:templateId/archive
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::archive
 */
export async function whatsAppTemplateArchive(
	organisationId: WhatsAppTemplateArchivePathParams['organisationId'],
	templateId: WhatsAppTemplateArchivePathParams['templateId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppTemplateArchiveResponse>> {
	return axiosInstance.post(
		`/organisations/${organisationId}/whatsapp-templates/${templateId}/archive`,
		undefined,
		config,
	)
}
